import React from 'react';
import Company from "../../../../model2/company/company";
import {CompanyLogoSize} from "./@const";

type Props = {
    size?           : CompanyLogoSize
    preview?        : string,
    organization    : any //Company, //object

    onClick?        : callback,
    className?      : string
}

// const debug = "CompanyLogo"
const debug = false

export default class CompanyLogo extends React.Component<Props> {

    static defaultProps = {
        size: CompanyLogoSize.SIZE_22
    };


    renderLogoImage() {

        debug && console.log(debug, "renderLogoImage()")

        let iconSrc : string    = ''

        let iconFile = null;
        const classes = Classes("organization-logo", "s"+this.props.size, this.props.className);

        if (this.props.preview) {
            iconSrc = this.props.preview;
        } else {
            iconFile = this.props.organization ? this.props.organization.icon : null;
            if (iconFile) {
                switch (this.props.size) {
                    case CompanyLogoSize.SIZE_18:   iconSrc = gdConfig.mediaPath + "company/small/"+iconFile; break;
                    case CompanyLogoSize.SIZE_22:   iconSrc = gdConfig.mediaPath + "company/norm/"+iconFile; break;
                    case CompanyLogoSize.SIZE_80:
                    case CompanyLogoSize.SIZE_100:  iconSrc = gdConfig.mediaPath + "company/large/"+iconFile; break;
                    default:                        iconSrc = gdConfig.mediaPath + "company/norm/"+iconFile;
                }
            }
        }

        return (
            <div className={classes} onClick={this.props.onClick}>
                <img src={iconSrc} />
            </div>
        );
    }

    renderNoLogoImage() {

        debug && console.log(debug, "renderNoLogoImage()")

        const color =           _.get(this, 'props.organization.color', null);
        const abbreviation =    _.get(this, 'props.organization.abbreviation', '');
        const classes = Classes("organization-logo", "s"+this.props.size, this.props.className, color ? "gd-c-"+color : '');

        return (
            <div className={classes} onClick={this.props.onClick}>
                {abbreviation}
            </div>
        );
    }

    render() {
        debug && console.log(debug, "render() companyName=", this.props.organization.name, this.props.organization)

        if (this.props.preview || (this.props.organization && this.props.organization.icon)) return this.renderLogoImage();
        else return this.renderNoLogoImage();
    }
}
